import { Pipe, PipeTransform } from '@angular/core';
import {
  CompleteStatus,
  Experiment,
  ExperimentSource,
  User,
} from '../services/labpartner.service.model';
import { ROLE_NAMES } from '../services/user-account.service';

@Pipe({
  name: 'canEditExperiment',
  standalone: false,
})
export class CanEditExperimentPipe implements PipeTransform {
  constructor() {}

  transform(user?: User, currentRoles?: string[], experiment?: Experiment): boolean {
    if (!experiment || !currentRoles) {
      return false;
    }

    if (experiment.source === ExperimentSource.LabPartner) {
      const isAdmin = currentRoles.indexOf(ROLE_NAMES.ADMIN) != -1;
      if (isAdmin) {
        return true;
      }

      const isWriter = currentRoles.indexOf(ROLE_NAMES.WRITER) != -1;
      if (isWriter && user && experiment.status != CompleteStatus) {
        return true;
      }

      return false;
    } else if (experiment.source === ExperimentSource.ImageCapture) {
      const isICWriter = currentRoles.indexOf(ROLE_NAMES.ICWRITER) != -1;
      if (isICWriter && user && experiment.status != CompleteStatus) {
        return true;
      }

      return false;
    }

    return false; // Default case if no conditions are met
  }
}
